/**
 * Air routing service
 *
 *
 */

//Vanilla
import _forEach from 'lodash-es/forEach';
import * as moment from 'moment';

import {Injectable} from '@angular/core';

// Import RxJs required methods



@Injectable()
export class RoutingService {

    public data: any = {
        'list': {},
        'listDisabled': {}
    };

    /**
     * get Full Routing
     *
     * get a full routing string from a sectors collection
     * @param {any} _sector : sector collection
     */
    public getFullRouting(_sector: any, _journey: any): string {
        let output: string = '';
        _forEach(_sector, (_value: any, _key: string) => {
            output += this.getAirportCode(_value.from) + this.getAirportCode(_value.to) + "_";
            output += _value.carrier.code + "_";
            output += moment(_value.begin).format("YYYY-MM-DD") + "_";
        });
        return output;
    }

    /**
     * compareRouting
     *
     * compare 2 Routing
     * @param {string} _referenceRouting : reference routing
     * @param {string} _newRouting : new routing to compare
     */
    public isSameRouting(_referenceRouting: string, _newRouting: string): boolean {
        return _referenceRouting === _newRouting;
    }

    /**
     * getAirportCode
     * get aiport code dependig of structure of json
     * @param {any} _way : 'to':{} or 'from':{}
     */
    public getAirportCode(_way: any): string {
        if (_way.type === "Airport") {
            return _way.code;
        } else if (_way.airport) {
            return _way.airport.code;
        } else {
            return '';
        }
    }


}
